/* eslint-disable */
import {defineRule, configure} from "vee-validate";
import {
    required, min, max, confirmed, min_value, max_value, is, regex,
} from "@vee-validate/rules";
import {localize} from "@vee-validate/i18n";
import {messagesPL} from "./messages/messages_pl";

defineRule("required", required);
defineRule("min", min);
defineRule("max", max);
defineRule("min_value", min_value);
defineRule("max_value", max_value);
defineRule("confirmed", confirmed);
defineRule("is", is);
defineRule("regex", regex);

/*
 * Sprawdza czy hasło spełnia warunki:
 * Minimum jedna duża litera
 * Minimum jedna mała litera
 * Minimum jedna cyfra
 * Minimum jeden znak specjalny
 * Minimum 8 znaków
 */
defineRule("validPassword", (value) => {
    if (!value || !value.length) {
        return false;
    }

    let regexExp = new RegExp("^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()\\[\\]{};:+=|,<.>\\`~£§?/'\\-\\_\"])(?=.*[a-zA-Z]).{8,}$");

    if (!regexExp.test(value)) {
        return false;
    }

    return true;
});

defineRule("email", value => {
    // Field is empty, should pass
    if (!value || !value.length) {
        return true;
    }

    // Check if email
    if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
        return false;
    }

    return true;
});

defineRule("phoneNumber", value => {
    if (!value || !value.length) {
        return true;
    }

    if (!/^\d{6,15}$/.test(value)) {
        return false;
    }

    return true;
})

defineRule("phoneNumberPL", value => {
    if (!value || !value.length) {
        return true;
    }

    if (!/^\d{9}$/.test(value)) {
        return false;
    }

    return true;
})

defineRule('notEmpty', (value) => {
    if (!value || !Array.isArray(value) || value.length === 0) {
        return false;
    }

    return true;
})

defineRule("postCode", value => {
    // Field is empty, should pass
    if (!value || !value.length) {
        return true;
    }

    // Check if correct
    if (!/^[0-9]{2}-[0-9]{3}/.test(value)) {
        return false;
    }

    return true;
});

defineRule("dateAfter", (value, [timeBefore]) => {
    // Field is empty, should pass
    if (!value && !timeBefore) {
        return true;
    }

    //Check chronology
    if (timeBefore > value) {
        return false;
    }

    return true;
});

configure({
    generateMessage: localize("pl", {
        messages: messagesPL.validations,
    }),
});
